




























import { defineComponent, computed, ref, watch } from '~/utils/nuxt3-migration'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import CColor from '~/components/shared/configurable/CColor.vue'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { useNamespacedStore } from '~/compositions/store'
import { Searchable } from '~/models/search/types'

export default defineComponent({
  components: { CCustomSelect, CColor },
  props: facetHandlerComponentProps,
  setup(props) {
    const { state: classifiedSearchState } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )
    const { changeParam } = useClassifiedSearchFacet()

    const selectedColors = ref(props.selected || [])

    const options = computed(() =>
      (props.searchables || []).map((s: Searchable) => ({
        label: s.n,
        value: s.v,
        count: s.c
      }))
    )

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    watch(
      () => props.selected,
      (newValue: number[]) => {
        selectedColors.value = newValue || []
      }
    )

    function onColorsChange(value: number[]) {
      changeParam({
        name: props.urlArgNames[0],
        value
      })
    }

    function onClearButtonClick() {
      changeParam({
        name: props.urlArgNames[0],
        value: null
      })
    }

    return {
      loadingFacets,
      selectedColors,
      options,
      onClearButtonClick,
      onColorsChange
    }
  }
})
